// extracted by mini-css-extract-plugin
export default {"root":"IconNetworkNotification_root__i2Fj3"};